import styled from '@emotion/styled'

export const StyledNavigator = styled.div((props) => {
  const {
    theme: { dimensions },
  } = props
  return `
    font-size: ${dimensions.small.fontSize};
    margin-bottom: 20px;
  `
})
